import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// tailwind-merge must know the Nodus type scale: without it `text-body` (a size) and `text-fg-body` (a color) look
// like two colors and the size is dropped.
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: [
        "ui",
        "body",
        "nav",
        "subnav",
        "meta",
        "small",
        "badge",
        "overline",
        "mono",
        "log",
        "wordmark",
        "page-title",
        "resource-title",
        "section-title",
        "card-title",
        "card-title-compact",
        "stat-value",
        "chart-value",
      ],
    },
  },
});

/** Joins class names and lets later Tailwind utilities override earlier ones (the shadcn convention). */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
